import { useState, useEffect } from "react";
import { subscribeToast } from "../../hooks/useToast";
import { C, withAlpha } from "../../constants/theme";

const COLORS = {
  success: { bg: C.panel, border: withAlpha(C.success, "55"), icon: "✅", text: C.success },
  error:   { bg: C.panel, border: withAlpha(C.danger, "55"), icon: "❌", text: C.danger },
  warning: { bg: C.panel, border: withAlpha(C.warning, "55"), icon: "⚠️", text: C.warning },
  info:    { bg: C.panel, border: withAlpha(C.accent2, "55"), icon: "ℹ️", text: C.accent2 },
};

export function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToast(({ id, msg, type, duration }) => {
      setToasts(t => [...t, { id, msg, type }]);
      setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), duration);
    });
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={{
      position: "fixed", top: 16, right: 16, zIndex: 99999,
      display: "flex", flexDirection: "column", gap: 8,
      pointerEvents: "none",
    }}>
      {toasts.map(t => {
        const c = COLORS[t.type] || COLORS.success;
        return (
          <div key={t.id} style={{
            background: c.bg, border: "1px solid " + c.border,
            borderRadius: 12, padding: "12px 16px",
            display: "flex", alignItems: "center", gap: 10,
            boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
            minWidth: 220, maxWidth: 340,
            animation: "toastIn .25s cubic-bezier(.16,1,.3,1)",
            pointerEvents: "auto",
          }}>
            <span style={{ fontSize: 16, flexShrink: 0 }}>{c.icon}</span>
            <span style={{ fontSize: 13, color: c.text, fontWeight: 600, lineHeight: 1.4 }}>{t.msg}</span>
          </div>
        );
      })}
      <style>{`@keyframes toastIn { from { opacity:0; transform:translateX(40px) } to { opacity:1; transform:translateX(0) } }`}</style>
    </div>
  );
}
